const repairLogProfile = {
  title: "PERFIL DE REPARACIONES",
  tag: "TAG del Equipo",
  type: "Tipo de Equipo",
  date: "Fecha de Creación",
  createdby: "Creado Por",
  log: "Registro",
  deletebtn: "ELIMINAR REPARACIÓN",
  backbtn: "Atrás"
};

export default repairLogProfile;
